module.exports = __webpack_public_path__ + "img/rbc_amplify-min.04f54fa2.jpg";